import { render, staticRenderFns } from "./AffiliatesView.vue?vue&type=template&id=503af66a&"
import script from "./AffiliatesView.vue?vue&type=script&lang=js&"
export * from "./AffiliatesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('503af66a')) {
      api.createRecord('503af66a', component.options)
    } else {
      api.reload('503af66a', component.options)
    }
    module.hot.accept("./AffiliatesView.vue?vue&type=template&id=503af66a&", function () {
      api.rerender('503af66a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/AffiliatesView.vue"
export default component.exports